import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { Star, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const [wistiaLoaded, setWistiaLoaded] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !wistiaLoaded) {
        setWistiaLoaded(true);
        const playerScript = document.createElement('script');
        playerScript.src = 'https://fast.wistia.com/player.js';
        playerScript.async = true;
        document.head.appendChild(playerScript);
        const embedScript = document.createElement('script');
        embedScript.src = 'https://fast.wistia.com/embed/h21ptcep8k.js';
        embedScript.async = true;
        embedScript.type = 'module';
        document.head.appendChild(embedScript);
        observer.disconnect();
      }
    }, {
      rootMargin: '200px'
    });
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, [wistiaLoaded]);
  return <section className="pt-16 md:pt-24 pb-8 md:pb-16 px-4 bg-leather" data-id="element-116">
      <div className="max-w-7xl mx-auto" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-12 items-start" data-id="element-118">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-3" data-id="element-119">
            <h1 className="text-2xl md:text-5xl lg:text-7xl font-black text-[#E4D6B5] leading-tight mb-4 md:mb-8 uppercase tracking-tight" data-id="element-120">
              Aprende el método de los muebles plegables y crea tus primeras
              piezas en solo{' '}
              <span className="text-[#8B5A2B] drop-shadow-[0_4px_8px_rgba(0,0,0,0.9)]" data-id="element-121">
                48 HORAS
              </span>
            </h1>

          
            <h2 className="text-base md:text-xl lg:text-1xl text-[#C8B894] mb-2 md:mb-4 font-bold leading-relaxed" data-id="element-122">
              <span className="text-[#E4D6B5] font-black" data-id="element-123">Desde cero y paso a paso, incluso si nunca has trabajado la madera</span></h2>

            {/* Hero Image - LCP critical */}
            <div className="relative bg-[#0a0a0a] border-2 md:border-4 border-[#6F6F6F] shadow-[0_0_40px_rgba(0,0,0,0.9)] mb-4 md:mb-8 overflow-hidden" style={{
            aspectRatio: '800/600'
          }} data-id="element-124">
              <img src="https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_38_1.webp?v=1771862759" srcSet={[360, 480, 640, 800, 1000, 1200].map(w => `https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_38_1.webp?v=1771862759&width=${w} ${w}w`).join(', ')} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 60vw, 800px" alt="Método de Carpintería Plegable" className="w-full h-full object-cover" loading="eager" fetchPriority="high" decoding="async" width="800" height="600" data-id="element-125" />
            </div>            
          </div>      
        </div>
      </div>
    </section>;
}